import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const deleteFaqGroup = async (faqGroup?: string) => {
  if (!faqGroup) {
    console.error("No faq group ID provided to delete faq group");
    return;
  }

  try {
    const groupRef = doc(db, `faqGroups`, faqGroup);
    const faqsRef = collection(groupRef, "faqs");

    const faqsSnapshot = await getDocs(faqsRef);

    const faqsDeletionPromises = faqsSnapshot.docs.map((docSnapshot) =>
      deleteDoc(docSnapshot.ref),
    );

    await Promise.all(faqsDeletionPromises);

    await deleteDoc(groupRef);
  } catch (e) {
    console.error("Error occurred when deleting faq group", e);
  }
};
